module.exports = __webpack_public_path__ + "static/img/four.c17c6a8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/index/four.jpeg
// module id = aF3A
// module chunks = 202